export class ConstantesQubos  {
  constructor() {}
  public static strPATH = 'app';
  public static strDashboardPATH = 'app/dashboards';
  public static signosmatematicos = ['(',')','/','*','+','-','<','>',','];
  public static signos = ['=','>','>=','<','<=']
  public static Logicos = ['and','or']
}
export class formulasFunctions{
  
  static formulas(indic, n){
    var cadena = '';
    if(indic[`r${n}Usar`]){
      if(indic[`r${n}OpComparacion1`] >= 0){
        cadena = ConstantesQubos.signos[indic[`r${n}OpComparacion1`]] +' '+ indic[`r${n}Valor1`];
      }
      if(n == 5){
        if(ConstantesQubos.Logicos[indic[`r${n}Oplogico1`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion2`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}Oplogico1`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion2`]]} ${indic[`r${n}Valor2`]}`;
        }
        if(ConstantesQubos.Logicos[indic[`r${n}Oplogico2`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion3`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}Oplogico2`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion3`]]} ${indic[`r${n}Valor3`]}`;
        }
        if(ConstantesQubos.Logicos[indic[`r${n}Oplogico3`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion4`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}Oplogico3`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion4`]]} ${indic[`r${n}Valor4`]}`;
        }
      }else{
        if(ConstantesQubos.Logicos[indic[`r${n}OpLogico1`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion2`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}OpLogico1`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion2`]]} ${indic[`r${n}Valor2`]}`;
        }
        if(ConstantesQubos.Logicos[indic[`r${n}OpLogico2`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion3`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}OpLogico2`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion3`]]} ${indic[`r${n}Valor3`]}`;
        }
        if(ConstantesQubos.Logicos[indic[`r${n}OpLogico3`]] !== undefined && ConstantesQubos.signos[indic[`r${n}OpComparacion4`]] !== undefined){
          cadena+= ` ${ConstantesQubos.Logicos[indic[`r${n}OpLogico3`]]} ${ConstantesQubos.signos[indic[`r${n}OpComparacion4`]]} ${indic[`r${n}Valor4`]}`;
        }         
      }
    }
    return cadena;
  }
}
export class IndicadoresFunctions{
  constructor() {}
  static buscarsignomatematico(signo){
      var flag = false;
      for(var i = 0; i < ConstantesQubos.signosmatematicos.length;i++){
          if(signo == ConstantesQubos.signosmatematicos[i]){
              flag = true;
          }
      }
      return flag;
  }
  static buscarCuentaId(cuentaid,cuenta,variable,vartemp){
    var descripcion = cuentaid;
    var flag = false;
    for(var i = 0; i < cuenta.length;i++){
        if(cuentaid == cuenta[i].Id_Cuenta){
            descripcion = cuenta[i].Descripcion;
            flag = true;
        }
    }
    if(!flag)
        descripcion = this.buscarVariable(cuentaid,variable,vartemp);
    return descripcion;
  }
  static buscarVariable(cuentaid,variable,vartemp){
    var descripcion = cuentaid;
    var flag = false;
    for(var i = 0; i < variable.length;i++){
        if(cuentaid == variable[i].Id_Variable){
            descripcion = variable[i].Descripcion;
            flag = true;
        }
    }
    if(!flag){
        descripcion = this.buscarVarTemp(cuentaid,vartemp);
    }
    return descripcion;
  }
  static buscarVarTemp(cuentaid,vartemp){
      var descripcion = cuentaid;
      var flag = false;
      for(var i = 0; i < vartemp.length;i++){
          if(cuentaid == vartemp[i].Id_VarTemp){
              descripcion = vartemp[i].Descripcion;
              flag = true;
          }
      }
      return descripcion;
  }
  static BuscarCuentaIdInFormula(formula,cuenta,variable,vartemp){
    var inicio = 0, fin = 0;
    var cuentaid = "";
    var formulaFinal = "";
    if(formula.includes("IIF")){
        formulaFinal = "(activo - cartera vencida neta - bienes adjudicados - otros activos) / (depósitos + capital contable)";
    }else{
        for(var i = 0; i < formula.length;i++){
            if(this.buscarsignomatematico(formula[i])){
                formulaFinal = formulaFinal.concat(this.buscarCuentaId(cuentaid,cuenta,variable,vartemp).toLocaleLowerCase() + " " + formula[i] + " ");
                inicio = fin;
                cuentaid = "";
            }else{
                cuentaid = cuentaid.concat(formula[i]);
                fin = i;
            }
        }
    }
    formulaFinal = formulaFinal.concat(this.buscarCuentaId(cuentaid,cuenta,variable,vartemp).toLocaleLowerCase());
    formulaFinal = formulaFinal.replace("fca1","promedio activo")
    formulaFinal = formulaFinal.replace(" * 100","").replace("","").replace("","").replace("   "," ").replace("  "," ").replace("abs","").replace("iif","IIF");
    return formulaFinal;
  }
}